import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { supabase } from '../../../lib/supabase';
import { useToast } from '../../../hooks/useToast';

export const useProjectData = () => {
  const [projectData, setProjectData] = useState<any>(null);
  const [searchParams] = useSearchParams();
  const { showToast } = useToast();

  const fetchProjectData = async () => {
    try {
      const pwd = searchParams.get('pwd');
      
      const { data, error } = await supabase
        .from('projects')
        .select('*')
        .eq('url', window.location.origin)
        .single();

      if (error) {
        console.error('Error fetching project:', error);
        showToast('Failed to load project data', 'error');
        return null;
      }

      if (data) {
        console.log('Loaded project data:', data);
        setProjectData(data);
        return data;
      } else {
        showToast('Project not found', 'error');
        return null;
      }
    } catch (err) {
      console.error('Error fetching project:', err);
      showToast('Failed to load project data', 'error');
      return null;
    }
  };

  return {
    projectData,
    setProjectData,
    fetchProjectData,
  };
};